export default __webpack_public_path__ + "static/media/motorcycle-financing-bg.50080d78.jpg";